module.exports = __webpack_public_path__ + "img/consult_info6.e6972555.png";